/**
 * If the browser supports the crypto.randomUUID() function, use it. Otherwise, if the browser supports
 * the crypto.getRandomValues() function, use it. Otherwise, use a fallback function
 * @returns A random UUID
 */
export const randomUUID = () => {
    if (typeof (window.crypto.randomUUID) != 'undefined') {
        return window.crypto.randomUUID();
    }
    if (typeof (window.crypto.getRandomValues) != 'undefined') {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    return 'xxxxxxxx-xxxx-4444-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}



/**
 * It takes an object and returns a new object with the same keys and values, but sorted by key
 * @param obj - The object to sort
 * @returns A function that takes an object as an argument and returns a sorted object.
 */
export const ksort = (obj) => {
    var keys = Object.keys(obj).sort(),
        sortedObj = {};
    for (let i in keys) {
        sortedObj[keys[i]] = obj[keys[i]];
    }
    return sortedObj;
}


/**
 * If the number is a single digit, add a zero to the front of it
 */
export const formatZeroNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

//格式化价格, 千分位, 小数点后两位
export const formatPrice = (price) => {
    price = parseInt(price / 100);
    return price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}


//时间戳 转成 指定格式 时间
//YYYY-MM-DD HH:MM:SS
//YYYY年MM月DD日
export const formatTimestampToDate = (timestamp, format) => {
    const d = new Date(1000 * timestamp);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const hour = d.getHours();
    const minute = d.getMinutes();
    const second = d.getSeconds();

    var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
    var returnArr = [];

    returnArr.push(year);
    returnArr.push(formatZeroNumber(month));
    returnArr.push(formatZeroNumber(day));
    returnArr.push(formatZeroNumber(hour));
    returnArr.push(formatZeroNumber(minute));
    returnArr.push(formatZeroNumber(second));

    for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i]);
    }
    return format;
}



export const calculateAge = (birthday) => { // birthday is a date of seconds (Unix timestamp)
    var ageDifMs = Date.now() - birthday * 1000;
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const formValidatorRules = {
  certno: [
    {
      validator(val) {
        return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
      },
      message: '身份证号码格式不正确',
    },
  ],
  email: [
    {
      validator(val) {
        return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val);
      },
      message: '邮箱格式不正确',
    },
  ],
  qq: [
    {
      validator(val) {
        return /[1-9][0-9]{4,}/.test(val);
      },
      message: 'QQ号码格式不正确',
    },
  ],
  wechat: [
    {
      validator(val) {
        return /^[a-zA-Z][-_a-zA-Z0-9]{5,19}$/.test(val);
      },
      message: '微信号码格式不正确',
    },
  ],
};

export const idTypeOptions = [
  { value: 0, text: '身份证',},
  { value: 1, text: '护照',},
  { value: 2, text: '台胞证',},
  { value: 3, text: '港澳台通行证',},
];